export enum IinOrBinCheckResult {
    IIN,
    BIN,
    UNKNOWN
}

export const IIN_PATTERN = /^[0-9][0-9](0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])[0-6][0-9][0-9][0-9][0-9][0-9]$/;
// TODO: Проверить корректность паттерна для БИН
export const BIN_PATTERN = /^[0-9][0-9](0[1-9]|1[0-2])[4-6][0-4][0-9][0-9][0-9][0-9][0-9][0-9]$/;
export const EMAIL_PATTERN = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
export const PHONE_PATTERN_7 = /^\+77[04567][0-8]\d{7}$/i;
export const PHONE_PATTERN_77 = /^77[04567][0-8]\d{7}$/i;
export const PHONE_PATTERN_8 = /^87[04567][0-8]\d{7}$/i;
export const PHONE_PATTERN = /^\+?7[04567][0-8]\d{7,8}$/i;
export const PASSWORD = /^(?!.*([a-zA-Z\d])\1{7})[a-zA-Z\d\S]{8,}$/;
export const checkIinOrBinCheckSum = (iinBin: string) => {
    if (iinBin && iinBin.length === 12) {
        let sum = 0;
        for (let i = 0; i < 11; i++) {
            sum += (i + 1) * (+iinBin[i]);
        }
        if (sum % 11 === 10) {
            sum = 3 * (+iinBin[0]) + 4 * (+iinBin[1]) + 5 * (+iinBin[2]) + 6 * (+iinBin[3]) + 7 * (+iinBin[4]) + 8 * (+iinBin[5])
                + 9 * (+iinBin[6]) + 10 * (+iinBin[7]) + 11 * (+iinBin[8]) + (+iinBin[9]) + 2 * (+iinBin[10]);
        }
        return sum % 11 === (+iinBin[11]);
    } else {
        return false;
    }
};
export const isIinOrBin = (data?: string): IinOrBinCheckResult => {
    if (data && data.length == 12) {
        const attribute = +data.substring(4, 5);
        return attribute > 3 ? IinOrBinCheckResult.BIN : IinOrBinCheckResult.IIN
    } else {
        return IinOrBinCheckResult.UNKNOWN;
    }
}

export function isIin(iin?: string): boolean {
    return isIinOrBin(iin) === IinOrBinCheckResult.IIN && !!iin?.match(IIN_PATTERN) && checkIinOrBinCheckSum(iin);
}